const experiences = [
  {
    icon: 'ri-home-heart-line',
    title: 'PRIJAZNO DRUŽINAM',
    desc: 'Poseben otroški meni in prijetno vzdušje za vso družino. Visoki stolčki na voljo.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/e101ebbf386c71d7396975670c131308.png',
  },
  {
    icon: 'ri-wheelchair-line',
    title: 'DOSTOPNOST',
    desc: 'Prilagojen vhod, prostorna sedišča in sanitarije za osebe na invalidskih vozičkih.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/29f8a11afc46af1a93824a77eee0ece3.png',
  },
];

export default function ExperienceSection() {
  return (
    <section id="dozivetje" className="relative bg-background-50 py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="relative w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="font-label text-xs tracking-extra-wide text-primary-600 font-medium uppercase mb-3">
              DOŽIVETJE
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-3">
              Več kot samo kosilo.
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
              Dva razloga, zakaj je Gostilna Marta prava izbira za tvoj naslednji obisk.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {experiences.map((item, idx) => (
              <div
                key={idx}
                className="experience-card group relative bg-background-100 border border-background-200/70 hover:border-accent-300/50 rounded-lg p-8 md:p-10 transition-all duration-400 overflow-hidden"
              >
                <div className="absolute inset-0 pointer-events-none">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`Gostilna Marta – ${item.title.toLowerCase()}`}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/55 to-black/35 pointer-events-none"></div>

                <div className="relative z-10">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-white/20 mb-6 md:mb-8 transition-colors duration-300">
                    <i className={`${item.icon} text-white text-xl md:text-2xl`}></i>
                  </div>
                  <h3 className="font-heading text-xl md:text-2xl text-white font-light mb-3 md:mb-4">
                    {item.title}
                  </h3>
                  <p className="font-body text-sm md:text-base text-white/80 leading-relaxed">
                    {item.desc}
                  </p>
                </div>

                <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-accent-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-400 origin-left rounded-b-lg"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}